import styled from 'styled-components';

interface HeaderContainerProps {
  $isScrolled: boolean;
}

interface NavProps {
  $isMenuOpen: boolean;
}

export const HeaderContainer = styled.header<HeaderContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${({ $isScrolled }) =>
    $isScrolled ? 'rgba(255, 255, 255, 0.95)' : 'transparent'};
  backdrop-filter: ${({ $isScrolled }) =>
    $isScrolled ? 'blur(10px)' : 'none'};
  transition: all 0.3s ease;
  border-bottom: ${({ $isScrolled }) =>
    $isScrolled ? '1px solid #19727822' : 'none'};
`;

export const HeaderContent = styled.div<{ $isScrolled: boolean }>`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  /* Ocultar todo el contenido del header cuando está en la parte superior */
  opacity: ${({ $isScrolled }) => ($isScrolled ? 1 : 0)};
  pointer-events: ${({ $isScrolled }) => ($isScrolled ? 'auto' : 'none')};
  transition: opacity 0.3s ease;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const Logo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const LogoText = styled.h1<{ $isScrolled?: boolean }>`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ $isScrolled }) => ($isScrolled ? '#197278' : '#fff')};
  margin: 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const LogoSubtext = styled.span<{ $isScrolled?: boolean }>`
  font-size: 0.875rem;
  color: ${({ $isScrolled }) => ($isScrolled ? '#5ca39b' : '#fff')};
  font-weight: 500;
`;

export const Nav = styled.nav<NavProps>`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    position: fixed;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    flex-direction: column;
    padding: 2rem;
    gap: 1.5rem;
    transform: ${({ $isMenuOpen }) =>
      $isMenuOpen ? 'translateY(0)' : 'translateY(-100%)'};
    opacity: ${({ $isMenuOpen }) => ($isMenuOpen ? 1 : 0)};
    visibility: ${({ $isMenuOpen }) => ($isMenuOpen ? 'visible' : 'hidden')};
    transition: all 0.3s ease;
    border-top: 1px solid #19727822;
  }
`;

export const NavLink = styled.button`
  background: none;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 0.5rem 0;

  &:hover {
    color: #197278;
  }

  @media (max-width: 768px) {
    font-size: 1.125rem;
    width: 100%;
    text-align: center;
    padding: 1rem 0;
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #374151;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`; 